export default __webpack_public_path__ + "static/media/AndroidApp.f3419bfd.svg";